export default __webpack_public_path__ + "static/media/call.45fc06f5.svg";